<template>
    <div >
      <img src="@/assets/logo.png" alt="Logo" class="form-logo">
      
      <div class="data-form">
        <div class="form-group date-input-container">
          <label for="fechoinicio">Fecha Inicio:</label>
          <input type="date" v-model="fechainicio"/>
          <span class="icon">📅</span>
        </div>
        <div class="form-group date-input-container">
          <label for="fechafin">Fecha Final:</label>
          <input type="date" v-model="fechafin"/>
          <span class="icon">📅</span>
        </div>
        <div class="form-group">
          <label for="selectedTableType">Tipo</label>
          <v-select :options="selectedTableType" label="name" v-model="this.tableSelected" :reduce="table => table.id"/>
        </div>
        <div>
          <button type="button" class="updateButton" @click="this.fillSpents">Actualizar</button>
          <button type="button" class="authorizeButton" @click="this.account">Marcar contabilizado</button>
          <button class="downloadButton" type="button" @click="downloadMaestrosGastos">Descargar XLSX</button>
        </div>
      </div>
        
      <!-- tabla -->
      <div class="expenses-table">
        <div class="table">
          <DataTable
            :value="this.filteredSpents"
            paginator
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20]"
            responsiveLayout="scroll"
            :filters="filters"
            filterDisplay="row"
            editMode="cell" @cell-edit-complete="onCellEditComplete"
            :pt="{
                table: { style: 'min-width: 50rem' },
                column: {
                    bodycell: ({ state }) => ({
                        class: [{ '!py-0': state['d_editing'] }]
                    })
                }
            }"
          >
            <Column field="autorizadopor" header="autorizadopor" v-if="filteredSpents.some(item => item.autorizadopor !== undefined)">
              <template #filter>
                <Select 
                v-model="filters.autorizadopor.value" 
                :options="uniqueAutorizadoPor" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="AutorizadoPor"
                size="small"
                showClear
                :autoAlign="false"
              />
              </template>
              <template #body="{ data }">
                {{ data.autorizadopor }}
              </template>
            </Column>

            <Column 
              v-for="col in tableColumns.filter(column => !['contabilidad', 'autorizadopor', 'responsable', 'municipio', 'nombregasto'].includes(column))" 
              :key="col" 
              :field="col" 
              :header="col" 
              :sortable="true"
              :filter="true"
              :showFilterMenu="false"
              removableSort
              >
              <template #body="{ data }">
                  <!-- Checkbox solo para 'contabilizado' -->
                  <Checkbox 
                      :key="data.id" 
                      v-if="col === 'contabilizado'" 
                      v-model="data.contabilizado" 
                      :disable="!!data.contabilizadopor"
                      @change="updateFieldAuthorized($event, data)"
                  />

                  <!-- Clickable para ciertos campos -->
                  <span v-else-if="col === 'iddetallegasto' || col === 'idmaestrogasto'" class="clickable" @click="showDetails(data)">
                      {{ data[col] }}
                  </span>

                  <!-- Contenido normal -->
                  <span v-else>{{ data[col] }}</span>
              </template>
          </Column>

          <Column field="contabilidad" header="contabilidad" editMode="cell"
              @cell-edit-complete="onCellEditComplete"
              :editable="col === 'contabilidad'">
            <template #editor="{ data, field }">
                  <template v-if="field === 'contabilidad'">
                      <InputText v-model="data[field]" autofocus fluid />
                  </template>
              </template>
          </Column>


            <Column field="municipio" header="municipio" v-if="filteredSpents.some(item => item.municipio !== undefined)">
              <template #filter>
                <Select 
                v-model="filters.municipio.value" 
                :options="uniqueMunicipio" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="Municipios"
                showClear 
                size="small"
                :autoAlign="false"
              />
              </template>
              <template #body="{ data }">
                {{ data.municipio }}
              </template>
            </Column>

              <Column field="responsable" header="responsable" >
                <template #filter>
                  <Select 
                  v-model="filters.responsable.value" 
                  :options="uniqueResponsables" 
                  optionLabel="label" 
                  optionValue="value" 
                  placeholder="Responsable"
                  size="small"
                  showClear
                  :autoAlign="false"
                />
                </template>
                <template #body="{ data }">
                  {{ data.responsable }}
                </template>
              </Column>

              <Column field="nombregasto" header="nombregasto">
                <template #filter>
                  <Select 
                    v-model="filters.nombregasto.value" 
                    :options="uniqueNombreGasto" 
                    optionLabel="label" 
                    optionValue="value" 
                    placeholder="Nombre Gasto"
                    size="small"
                    showClear
                    :autoAlign="false"
                  />
                </template>
                <template #body="{ data }">
                  {{ data.nombregasto }}
                </template>
              </Column>
  
          </DataTable>
        </div>
  
        <!-- Segunda tabla para detalles -->
        <div class="details-sidebar">
          <h3>Detalles del Gasto</h3>
          <div v-if="selectedGasto">
            <div v-for="(value, key) in selectedGasto" :key="key" class="gasto-item">
              <strong>{{ key }}:</strong>
              <span v-if="key !== 'urlanexo'">{{ value }}</span>
              <span v-else>
                <span v-if="this.tableSelected === 'mg'">
                  <a :href="value" target="_blank" class="adjunto-link">
                      Carpeta
                  </a>
                </span>
                <span v-else>
                  <ul class="adjuntos-list">
                  <li v-for="(url, index) in value" :key="index">
                    <a :href="url" target="_blank" class="adjunto-link">
                      Adjunto {{ index + 1 }}
                    </a>
                  </li>
                </ul>
                </span>
                
              </span>
            </div>
          </div>
          <p v-else class="no-gasto">Selecciona un gasto para ver los detalles.</p>
          </div>
      </div>
    </div>
  
      <!-- Tabla de gastos -->
      
  </template>
  
  <script>
  
  import vSelect from 'vue-select';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Checkbox from 'primevue/checkbox';
  import Select  from "primevue/select";
  import InputText from "primevue/inputtext";
  
  import { selectSpentDetail, selectMaestroGastosByUser, selectUsersWithSpents, tokenValidation, selectIdByEmail, selectObtener_SpentsToAccount, selectObtener_archivos, accountSpents } from '@/api/api';
  export default {
    components: { DataTable, Column, vSelect, Checkbox, Select, InputText },
    data() {
      return {
        crSpentsUsers: [],
        maestroGasto: [],
        spentSelected: null,
        selectedTableType: [{ id: 'mg', name: 'Maestro de gastos' }, { id: 'gcs', name: 'Gastos con soporte' }, { id: 'ass', name: 'Alimentación SS' }, { id: 'tss', name: 'Transporte SS' }],
        tableSelected: null, // Tipo de tabla seleccionada
        spents: [], // Datos de la tabla
        selectedGasto: null,
        expenses: [{autorizado: null}],
        tableColumns: [], // Columnas visibles
        tableWithChangesAuthorize: [],
        tableWithChangesUnauthorize: [], // Agregar logica para desautorizar gastos
        correousuario: null,
        iduser: null,
        fechainicio: null,
        fechafin: null,
        filters: {
          municipio: { value: null, matchMode: 'equals' },
          responsable: { value: null, matchMode: 'equals' },
          nombregasto: { value: null, matchMode: 'equals' },
          autorizadopor: { value: null, matchMode: 'equals' },
        },
      }
    },
    watch:{
      tableSelected(newValue){
        this.selectedGasto = null
        this.setTableColumns(newValue)
        this.fillSpents()
      }
    },
    computed: {
      uniqueAutorizadoPor() {
          return [{ label: "Todos", value: null }, 
            ...Array.from(new Set(this.filteredSpents.map(item => item.autorizadopor)))
              .filter(mun => mun !== undefined)
              .map(mun => ({ label: mun, value: mun }))
          ];
        },
      uniqueMunicipio() {
          return [{ label: "Todos", value: null }, 
            ...Array.from(new Set(this.filteredSpents.map(item => item.municipio)))
              .filter(mun => mun !== undefined)
              .map(mun => ({ label: mun, value: mun }))
          ];
        },

        uniqueResponsables() {
          return [{ label: "Todos", value: null }, 
            ...Array.from(new Set(this.filteredSpents.map(item => item.responsable)))
              .filter(resp => resp !== undefined)
              .map(resp => ({ label: resp, value: resp }))
          ];
        },

        uniqueNombreGasto() {
          return [{ label: "Todos", value: null }, 
            ...Array.from(new Set(this.filteredSpents.map(item => item.nombregasto)))
              .filter(nom => nom !== undefined)
              .map(nom => ({ label: nom, value: nom }))
          ];
        },

        filteredSpents() {
        return this.spents.filter(item => 
          (!this.filters.municipio.value || this.filters.municipio.value.length === 0 || this.filters.municipio.value.includes(item.municipio)) &&
          (!this.filters.responsable.value || this.filters.responsable.value.length === 0 || this.filters.responsable.value.includes(item.responsable)) &&
          (!this.filters.nombregasto.value || this.filters.nombregasto.value.length === 0 || this.filters.nombregasto.value.includes(item.nombregasto))
        );
      },
      authorizedColumns() {
        return this.tableColumns.filter((col) => this.checkAuthorization(col));
      },
    },
    created() {
      // Define el tipo de tabla que deseas mostrar.
      this.setTableColumns('mg');
    },
    mounted() {
      this.reloadPage();
      
    },
    methods: {
      onCellEditComplete(event) {
        let { data, field, newValue } = event;

        if (field === "contabilidad") {
          // Si el valor es null o undefined, asignamos una cadena vacía en su lugar
          data[field] = newValue ? newValue.trim() : "";
        }

        event.preventDefault(); // Evita que PrimeVue busque otra celda editable y genere errores
      },
      showDetails(gasto) {
        this.selectedGasto = gasto; // Guardar el gasto seleccionado para mostrar detalles
      },
      async downloadMaestrosGastos() {
          try {
            const form = {
              type: this.tableSelected,
              startDate: this.fechainicio,
              endDate: this.fechafin
            };
            await selectObtener_archivos(form);
            
            alert('Archivo creado con éxito en OneDrive (CLZGastos/Consultas)');
            
          } catch (err) {
            console.error(err);
            alert('Error al crear archivo con la consulta');
            window.location.reload();
          }
        },
       // Función para validar la autorización de la columna
       checkAuthorization(col) {
        // Aquí incluyes tu lógica de autorización.
        // Por ejemplo, si deseas autorizar todas excepto 'noMostrar':
        return col !== 'noMostrar';
      },
      async fillSpents() {
        if (!this.fechainicio || !this.fechafin) {
          alert("Seleccione el rango de fechas")
          return
        }
        const form = {
                type: this.tableSelected,
                startDate: this.fechainicio,
                endDate: this.fechafin
              };
        const result = await selectObtener_SpentsToAccount(form);
        this.spents = result.data
  
      },
      fieldVerification() {
        if(this.spentSelected && this.tableSelected) {
          this.setTableColumns(this.tableSelected);
          this.fetchExpenses();
        }
      },
      updateFieldAuthorized(event, expense) {
      
        let dateTimeActual = new Date(Date.now());
          dateTimeActual.setHours(dateTimeActual.getHours() - 5);
        if (event.target.checked) {
          expense.contabilizadopor = this.correousuario; // Cambia según el estado del checkbox
          this.tableWithChangesAuthorize.push({
            contabilizadopor: this.iduser,
            fechacontabilizacion: dateTimeActual,
            id: expense.iddetallegasto,
            comentarioscontabilidad: expense.contabilidad})
        } else {
          expense.contabilizadopor = null;
          this.tableWithChangesUnauthorize.push({idUser: this.idUser, fechaaprobado: dateTimeActual, id : expense.iddetallegasto, comentarioscontabilidad: expense.contabilidad})
        }
      },
      async account() { // Marcar contabilizado en BD
        try {
          const tableType = this.tableSelected;
          await accountSpents(this.tableWithChangesAuthorize, tableType);
          alert('Gastos contabilizados');
          this.tableWithChangesAuthorize = [];
          this.fillSpents();
        } catch(err) {
          console.error(err);
        }
      },
      async reloadPage() { // Recarga la pagina en caso de que el token haya caducado
        let ValidToken = await tokenValidation();
        try {
          if(ValidToken.data == undefined || ValidToken.data === false) {
            window.location.reload();
          } else {
            this.correousuario = ValidToken.data;
            const idOfUser = await selectIdByEmail(this.correousuario);
            this.iduser = idOfUser.data;
          }
  
        } catch (error) {
          console.error("Error al validar token", error);
          window.location.reload();
        }
      },
      setTableColumns(type) {
        if (type === 'mg') {
          this.tableColumns = ['idmaestrogasto', 'fechainicio', 'fechafin', 'responsable', 'nombregasto', 'tipogasto'];
        } else if (type === 'gcs') {
          this.tableColumns = ['autorizadopor', 'contabilizadopor',  'contabilizado', 'iddetallegasto', 'fechagasto', 'nombregasto', 'responsable', 'municipio', 'valor', 'contabilidad'];
        } else if (type === 'ass') {
          this.tableColumns = ['autorizadopor', 'contabilizadopor','contabilizado', 'iddetallegasto', 'responsable', 'fechagasto', 'nombregasto', 'desayuno', 'almuerzo', 'cena', 'contabilidad'];
        } else if (type === 'tss') {
          this.tableColumns = ['autorizadopor', 'contabilizadopor','contabilizado', 'iddetallegasto', 'fechagasto', 'nombregasto', 'responsable', 'valor', 'contabilidad'];
        }
      },
      async fetchExpenses() {
        try {
          this.expenses = [];
          const info = {id: this.spentSelected, tableType: this.tableSelected}
          const response = await selectSpentDetail(info);
          this.expenses = response.data.map(gasto => gasto);
          
        } catch (error) {
          console.error('Error al obtener los datos:', error);
        }
      },
      onExpensesSearch(input) {
        this.fetchExpenses(input);
      },
      async fecthGastos(value) {
        try {
          const response = await selectMaestroGastosByUser(value);
          this.maestroGasto = response.data.map(gasto => ({
            id: gasto.idviaje,
            nombreviaje: gasto.nombreviaje,
          }));
          if (this.maestroGasto.length >= 1) {
            this.spentSelected = this.maestroGasto[0].id;
          }
          if (!this.correousuario) {
            window.location.reload();
          }
        } catch (err) {
          console.error('Error obteniendo los gastos', err);
        }
      },
      onGastoSearch(input) {
        this.fecthGastos(input);
      },
      async fecthUsers(query) {
        try {
          const response = await selectUsersWithSpents(query);
          this.crSpentsUsers = response.data.map(user => ({
            id: user.id,
            cardCode: user.cardcode,
          }));
        } catch (err) {
          console.error('Error obteniendo los usuarios', err);
          window.location.reload();
        }
      },
      onUsersSearch(search) {
        this.fecthUsers(search);
      },
    }
  };
  </script>
  
  <style scoped>
  
  .expenses-table {
    display: flex;
    height: 100vh;
  }
  
  .table {
    width: 85%;
  }
  
  .container {
    display: flex; /* Asegura que la barra lateral y la tabla se distribuyan bien */
    gap: 20px;
    flex: 1;
    overflow: hidden;
  }
  
  .table-container {
    flex: 3; /* Toma más espacio */
    overflow-x: auto; /* Permite scroll si la tabla es muy ancha */
  }
  
  .details-sidebar {
    background-color: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 16px;
    max-width: 20%;
    border: 1px solid #e0e0e0;
    color:black;
    max-height: fit-content;
  }
  
  .details-sidebar h3 {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 8px;
    margin-bottom: 12px;
  }
  
  .gasto-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .gasto-item strong {
    color: #555;
  }
  
  .gasto-item span {
    color: #222;
  }
  
  .no-gasto {
    color: #888;
    font-style: italic;
    text-align: center;
    margin-top: 12px;
  }
  
  
  .clickable {
    color: blue;
    cursor: pointer;
    text-decoration: underline;
  }
  .form-group {
    max-width: fit-content;
    min-width: 210px;
    color: black;
    margin: 2px;
    max-height: fit-content;
  }
  
  /* Estilo básico para la tabla */
  .p-datatable {
    max-width: 100%;
    border-collapse: collapse;
  }
  
  .p-datatable th,
  .p-datatable td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  
  .p-datatable th {
    background-color: #f4f4f4;
    text-align: left;
  }
  
  .p-datatable tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  .link {
    color: blue;
    text-decoration: underline;
    font-weight: bold;
  }
  .link:hover {
    color: darkblue;
  }
  </style>